module.exports = "pegasus/assets/themelp1/large/51.png";